module.exports = __webpack_public_path__ + "static/media/stod2_401_error.3ef9ad3a.png";